if (!customElements.get('loom-cart-drawer')) customElements.define('loom-cart-drawer', class extends HTMLElement {
  connectedCallback() {
    this.events = new AbortController();
    this.dialog = this.querySelector('dialog');
    this.status = this.querySelector('.lc-status');
    const on = (el, name, fn) => el.addEventListener(name, fn, {signal:this.events.signal});
    on(document, 'click', e => {
      const link = e.target.closest('.loom-cart-link, .lp-cart-success');
      if (!link || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
      e.preventDefault(); this.show(link);
    });
    on(this, 'click', e => {
      if (e.target.closest('[data-lc-close]')) this.dialog.close();
      if (e.target.closest('[data-lc-retry]')) this.refresh();
      const button = e.target.closest('[data-lc-key]');
      if (button) this.change(button.dataset.lcKey, Number(button.dataset.quantity));
      if (e.target === this.dialog && e.clientX < this.dialog.getBoundingClientRect().left) this.dialog.close();
    });
    on(this.dialog, 'close', () => {document.documentElement.style.overflow = this.oldOverflow || ''; this.opener?.focus({preventScroll:true});});
  }
  async show(opener) {
    if (!this.dialog.open) {
      this.opener = opener || document.activeElement;
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
    }
    await this.refresh();
  }
  async refresh() {
    if (this.busy) return;
    this.setBusy(true);
    this.status.textContent = this.dataset.loading;
    this.querySelector('.lc-recovery').hidden = true;
    try {
      const res = await fetch(this.dataset.cartUrl.replace(/\/$/,'') + '.js', {credentials:'same-origin',cache:'no-store',signal:this.events.signal});
      if (!res.ok) throw new Error();
      this.render(await res.json());
    } catch (e) { if (e.name !== 'AbortError') this.fail(); }
    finally { this.setBusy(false); }
  }
  setBusy(value) {
    this.busy = value;
    this.setAttribute('aria-busy', String(value));
    this.querySelectorAll('[data-lc-key],.lc-checkout').forEach(b => b.disabled = value || this.failed);
  }
  fail(message) {
    this.failed = true;
    this.status.textContent = message || this.dataset.error;
    this.querySelector('.lc-recovery').hidden = false;
  }
  render(cart) {
    this.failed = false;
    const numeric = n => (typeof n === 'number' || (typeof n === 'string' && n.trim() !== '')) && Number.isFinite(Number(n));
    const money = n => numeric(n) ? new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:cart.currency || 'EUR'}).format(Number(n)/100) : '';
    const container = this.querySelector('.lc-items'); container.replaceChildren();
    for (const item of cart.items) {
      const row = document.createElement('article'); row.className = 'lc-item';
      const img = document.createElement('img'); img.src = item.featured_image?.url || item.image || ''; img.alt = item.product_title; img.width = 90; img.height = 90;
      const copy = document.createElement('div'); copy.className = 'lc-copy';
      const name = document.createElement('a'); name.textContent = item.product_title; name.href = item.url;
      const variant = document.createElement('p'); variant.textContent = item.variant_title === 'Default Title' ? '' : item.variant_title;
      const price = document.createElement('strong'); price.textContent = money(item.final_line_price);
      const controls = document.createElement('div'); controls.className = 'lc-controls';
      const makeButton = (text, quantity, label) => {const b = document.createElement('button'); b.type='button'; b.textContent=text; b.dataset.lcKey=item.key; b.dataset.quantity=quantity; b.setAttribute('aria-label',label+' – '+item.product_title); return b;};
      const count = document.createElement('span'); count.textContent = item.quantity;
      const remove = makeButton(this.dataset.remove, 0, this.dataset.remove); remove.className='lc-remove';
      controls.append(makeButton('−', item.quantity-1, this.dataset.less),count,makeButton('+',item.quantity+1,this.dataset.more),remove);
      const prices = document.createElement('div'); prices.className='lc-line-prices';
      if (item.original_line_price > item.final_line_price) { const original=document.createElement('s'); original.textContent=money(item.original_line_price); prices.append(original); }
      prices.append(price);
      const discounts=document.createElement('div'); discounts.className='lc-line-discounts';
      for (const allocation of item.line_level_discount_allocations || []) {
        const label=document.createElement('p'); label.textContent=(allocation.discount_application?.title || this.dataset.discountLabel)+(numeric(allocation.amount)?' −'+money(allocation.amount):''); discounts.append(label);
      }
      copy.append(name,variant,prices,discounts,controls);row.append(img,copy);container.append(row);
    }
    this.status.textContent = cart.item_count ? '' : this.dataset.empty;
    this.querySelector('footer').hidden = !cart.item_count;
    this.querySelector('[data-lc-total]').textContent = money(cart.total_price);
    const orderDiscounts=cart.cart_level_discount_applications || [];
    const discountBox=this.querySelector('.lc-discounts'); discountBox.replaceChildren();
    for(const discount of orderDiscounts) {
      const row=document.createElement('div'); row.className='lc-discount-row';
      const title=document.createElement('span');
      const rawName=String(discount.title || discount.code || '').trim();
      const quantityOffer=rawName.match(/^Mengenrabatt\s*[-–]?\s*(\d+(?:[.,]\d+)?)\s*%$/i);
      const discountName=quantityOffer?`${quantityOffer[1]} % Mengenrabatt`:rawName;
      title.textContent=this.dataset.discountLabel+(discountName?' – '+discountName:'');
      const amount=document.createElement('strong');
      let discountAmount=discount.total_allocated_amount;
      if (!numeric(discountAmount) && orderDiscounts.length===1 && numeric(cart.items_subtotal_price) && numeric(cart.total_price)) {
        discountAmount=Math.max(0,Number(cart.items_subtotal_price)-Number(cart.total_price));
      }
      amount.textContent=numeric(discountAmount)?'−'+money(discountAmount):'';
      row.append(title,amount);discountBox.append(row);
    }
    this.querySelector('.lc-subtotal').hidden=!orderDiscounts.length;
    this.querySelector('[data-lc-subtotal]').textContent=money(cart.items_subtotal_price ?? cart.total_price);
    this.querySelector('.lc-bulk-next').hidden=cart.item_count!==1;
    this.querySelector('.lc-recovery').hidden = true;
    document.querySelectorAll('.loom-cart-link span').forEach(el => el.textContent = cart.item_count);
  }
  async change(key, quantity) {
    if (this.busy) return;
    this.setBusy(true);this.status.textContent = this.dataset.loading;
    try {
      const res = await fetch(this.dataset.changeUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity}),signal:this.events.signal});
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || this.dataset.error);
      const snapshot=await fetch(this.dataset.cartUrl.replace(/\/$/,'')+'.js',{credentials:'same-origin',cache:'no-store',signal:this.events.signal});
      if (!snapshot.ok) throw new Error(this.dataset.error);
      this.render(await snapshot.json());
      this.querySelector('[data-lc-close]').focus({preventScroll:true});
    } catch(e) {if(e.name !== 'AbortError') this.fail(e.message);}
    finally {this.setBusy(false);}
  }
  disconnectedCallback() {if(this.dialog?.open)this.dialog.close();this.events?.abort();}
});
